import { dayjsInit } from './time'

export const getAddress = (data) => {
  if (data.extInfo) {
    return data.extInfo.address || ''
  }
  if (data.address) {
    return data.address
  }
  return ''
}

export const getLnglat = (data) => {
  const str = data.extInfo ? data.extInfo.lnglat || '' : data.lnglat
  if (str && str.length > 1) {
    const lnglat = [Number(str[0]).toFixed(6), Number(str[1]).toFixed(6)].join(
      ','
    )
    return lnglat
  }

  return str || ''
}

export const getTime = (data) => {
  if (data.extInfo) {
    return data.extInfo.catchTime || null
  }
  if (data.time) {
    return data.time
  }
  if (data.createdAt) {
    return data.createdAt
  }
  return null
}

export const getWaterMarkDefsItemInfo = (waterMarkDefs, data) => {
  const arr = (waterMarkDefs || []).map((item) => {
    const { slug, type, fieldType } = item
    if (type === 'convention') {
      if (slug === 'date') {
        return getTime(data)
          ? dayjsInit(getTime(data)).format('YYYY-MM-DD HH:mm:ss')
          : ''
      }
      if (slug === 'address') {
        return getAddress(data)
      }
      if (slug === 'lnglat') {
        return getLnglat(data)
      }
    }
    if (type === 'dataField') {
      if (fieldType === 'date') {
        return data[slug]
          ? dayjsInit(data[slug]).format('YYYY-MM-DD HH:mm:ss')
          : ''
      }
      return data[slug]
    }
    return null
  })
  return arr.filter((v) => v)
}
